import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'
import { ICON_NAMES } from '../../../constants'
import FlexColumn from '../FlexColumn'
import FlexRow from '../FlexRow'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'
import DenaliActionMenu from '../../organisms/DenaliActionPipeline/triggers/DenaliActionMenu'

/**
 * Represents an individual activity item that is a meeting
 * @param activity
 * @param onClick
 * @param actions - array of action menu specifications
 * @param className
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
function MeetingActivity ({ activity, onClick, actions, className, style }) {
  const { formatter } = useFormattingContext()

  return (
    <div
      className={clsx(className, 'flex flex-row gap-lg radius-md opal-card px-3 py-2', { 'opal-selectable': !!onClick })}
      style={{ fontWeight: '100', ...(style || {}) }}
    >
      <div
        className={clsx(className, 'flex flex-row gap-lg flex-1', { clickable: !!onClick })}
        onClick={onClick}
      >
        <div className='flex justify-center items-center px-1'>
          <Icon name={ICON_NAMES.calendar} customSize={20} />
        </div>
        <FlexColumn className='flex-auto'>
          <FlexRow className='justify-between'>
            <strong>{activity.subject}</strong>
            <span>{formatter(activity.startDate, 'date')}</span>
          </FlexRow>
          <FlexRow className='justify-end'>
            <span>{formatter(activity.startDate, 'timeAbsolute')}</span>
            <span>-</span>
            <span>{formatter(activity.endDate, 'timeAbsolute')}</span>
            {activity.timezone ? <span>{activity.timezone}</span> : null}
          </FlexRow>
        </FlexColumn>
      </div>
      {actions?.length ? (
        <DenaliActionMenu actions={actions} subject={activity} />
      ) : null}
    </div>
  )
}

MeetingActivity.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.string,
    subject: PropTypes.string,
    completed: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    timezone: PropTypes.string
  }).isRequired,
  actions: PropTypes.array,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
}

export default MeetingActivity
